<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="!salesDelivery">
      <span class="loader"></span>
    </span>
    <div v-if="salesDelivery" class="elite-tabs-wrapper">
      <tabs
        fill
        class="flex-column flex-md-row"
        tabNavWrapperClasses="nav-wrapper"
        tabNavClasses="nav elite-tabs"
        :value="currentTab"
        @onTabChanged="tabChanged"
      >
        <tab-pane title="global" id="1" :active="false">
          <span slot="title">
            <i class="ni ni-cloud-upload-96"></i>
            {{ $t("COMMON.GLOBAL") }}
          </span>
          <sales-delivery-view-global :salesDelivery="salesDelivery" />
        </tab-pane>

        <tab-pane title="details" id="2" :active="false">
          <span slot="title">
            <i class="ni ni-bullet-list-67"></i>
            {{ $t("COMMON.DETAILS") }}
          </span>
          <sales-delivery-view-details
            :salesDelivery="salesDelivery"
            @salesDeliveryItemsUpdated="get"
          />
        </tab-pane>

        <tab-pane
          title="files"
          id="998"
          v-if="
            $currentUserCan($permissions.PERM_VIEW_ANY_FILES) &&
            salesDelivery.organization
          "
        >
          <span slot="title">
            <i class="ni ni-folder-17"></i>
            {{ $t("COMMON.FILES") }}
          </span>
          <div class="elite-tabs-wrapper-content">
            <list-file-component :object="salesDelivery" />
          </div>
        </tab-pane>

        <tab-pane
          title="logs"
          id="999"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_LOGS)"
        >
          <span slot="title">
            <i class="fa fa-file"></i>
            {{ $t("COMMON.LOGS") }}
          </span>
          <sales-delivery-view-logs :salesDelivery="salesDelivery" />
        </tab-pane>
      </tabs>
    </div>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import requestErrorMixin from "@/mixins/request-error-mixin";
import { Tabs, TabPane } from "@/components";
import ListFileComponent from "@/components/File/ListFileComponent.vue";
import SalesDeliveryViewGlobal from "../partials/SalesDeliveryViewGlobal.vue";
import SalesDeliveryViewDetails from "../partials/SalesDeliveryViewDetails.vue";
import SalesDeliveryViewLogs from "../partials/SalesDeliveryViewLogs.vue";
import hasTabs from "@/mixins/has-tabs";

export default {
  layout: "DashboardLayout",

  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    Tabs,
    TabPane,
    SalesDeliveryViewGlobal,
    SalesDeliveryViewDetails,
    SalesDeliveryViewLogs,
    ListFileComponent,
  },

  mixins: [requestErrorMixin, hasTabs],

  props: {
    salesDeliveryId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      loading: false,
      salesDelivery: null,
    };
  },

  computed: {},

  watch: {},

  created() {
    this.get();
  },

  methods: {
    async get() {
      try {
        await this.$store.dispatch("salesDeliveries/get", this.salesDeliveryId);
        this.salesDelivery =
          this.$store.getters["salesDeliveries/salesDelivery"];
        this.$emit("salesDeliveryLoaded", this.salesDelivery);
      } catch (error) {
        this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },
  },
};
</script>
